import { isPhone, validURL, validEmail } from '@/utils/validate'

// 手机号码格式校验
export function validPhone (rule, value, callback) {
  if (!value) {
    callback()
  } else if (isPhone(value)) {
    callback()
  } else {
    callback(new Error('格式不正确'))
  }
}

// 网址格式校验
export function validUrl (rule, value, callback) {
  if (!value) {
    callback()
  } if (validURL(value)) {
    callback()
  } else {
    callback(new Error('格式不正确'))
  }
}

// 邮箱格式校验
export function emailValid (rule, value, callback) {
  if (!value) {
    callback()
  } if (validEmail(value)) {
    callback()
  } else {
    callback(new Error('格式不正确'))
  }
}

// 大于等于0的两位小数
export function gteZero2 (rule, value, callback) {
  let reg = /^(?:[1-9]\d*|0)(?:\.\d{1,2})?$/
  if (!value || reg.test(value)) {
    callback()
  } else {
    callback(new Error('请填写大于等于0的两位小数'))
  }
}

// 验证正整数+0
export function checkIsPositiveInteger (rule, value, callback) {
  const reg = /^(0|[1-9][0-9]*)$/
  if (!value  || reg.test(value)) {
    callback()
  } else {
    callback(new Error('请输入大于等于0的整数'))
  }
}
